var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SelectionAny, SelectionFamilyRecord, SelectionHeader, SelectionIndividualRecord, SelectionMultimediaRecord, SelectionNoteRecord, SelectionRepositoryRecord, SelectionSourceRecord, SelectionSubmitterRecord } from './internal';
var SelectionGedcom = /** @class */ (function (_super) {
    __extends(SelectionGedcom, _super);
    function SelectionGedcom() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectionGedcom.prototype.getHeader = function () {
        return this.get("HEAD" /* Header */, null, SelectionHeader);
    };
    // TODO this method does the same thing as `get`, it can be remove
    SelectionGedcom.prototype.getRecord = function (tag, pointer, SelectionAdapter) {
        return this.get(tag, pointer, SelectionAdapter);
    };
    SelectionGedcom.prototype.getSubmitterRecord = function (pointer) {
        return this.getRecord("SUBM" /* Submitter */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionSubmitterRecord);
    };
    SelectionGedcom.prototype.getIndividualRecord = function (pointer) {
        return this.getRecord("INDI" /* Individual */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionIndividualRecord);
    };
    SelectionGedcom.prototype.getFamilyRecord = function (pointer) {
        return this.getRecord("FAM" /* Family */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionFamilyRecord);
    };
    SelectionGedcom.prototype.getMultimediaRecord = function (pointer) {
        return this.getRecord("OBJE" /* Object */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionMultimediaRecord);
    };
    SelectionGedcom.prototype.getNoteRecord = function (pointer) {
        return this.getRecord("NOTE" /* Note */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionNoteRecord);
    };
    SelectionGedcom.prototype.getSourceRecord = function (pointer) {
        return this.getRecord("SOUR" /* Source */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionSourceRecord);
    };
    SelectionGedcom.prototype.getRepositoryRecord = function (pointer) {
        return this.getRecord("REPO" /* Repository */, pointer !== null && pointer !== void 0 ? pointer : null, SelectionRepositoryRecord);
    };
    return SelectionGedcom;
}(SelectionAny));
export { SelectionGedcom };
//# sourceMappingURL=SelectionGedcom.js.map